import { applyMiddleware, createStore, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import reducer from "../reducers/reducer";
import rootSaga from "../sagas";

const store = () => {
  const sagaMiddleware = createSagaMiddleware();
  const configStore = createStore(
    reducer(),
    compose(
      applyMiddleware(sagaMiddleware),
      window.__REDUX_DEVTOOLS_EXTENSION__
        ? window.__REDUX_DEVTOOLS_EXTENSION__()
        : (f) => f
    )
  );

  sagaMiddleware.run(rootSaga);

  return configStore;
};

export default store;
